// Web port of client-native/src/features/lesson/lib/videoDisplayMode.ts.
// The backend serves a per-chapter `videoDisplayMode` enum on the lesson data
// response (domain.VideoDisplayMode: "" | "immersive" | "immersiveTranscript").
// It controls how the video player lays out captions / the action card.
//
//   - immersive            → overlay layout, captions hidden, buttons offset up
//   - immersiveTranscript  → overlay layout, captions shown, buttons offset up
//   - "" (default)         → overlay layout, captions shown
//
// `actionButtonsOffset` mirrors the native helper (immersive and
// immersiveTranscript both return -120). The web feed-based layout docks
// captions + action buttons inside the video column and doesn't currently read
// the offset, but the values are kept identical to iOS so the helper stays a
// faithful port. Keep this in lockstep with the native helper above.
export interface VideoDisplayModeProps {
  layoutMode: "overlay";
  hideCaptions: boolean;
  actionButtonsOffset?: number;
}

export function getVideoPropsForDisplayMode(
  mode: string | undefined
): VideoDisplayModeProps {
  switch (mode) {
    case "immersive":
      return {
        layoutMode: "overlay",
        hideCaptions: true,
        actionButtonsOffset: -120,
      };
    case "immersiveTranscript":
      return {
        layoutMode: "overlay",
        hideCaptions: false,
        actionButtonsOffset: -120,
      };
    default:
      return {
        layoutMode: "overlay",
        hideCaptions: false,
      };
  }
}
